import { CalendarDays, Compass, Flag, Folders } from "lucide-react";

import type { SidebarItem } from "@/types/navigation";

export const OPERATIONS_NAV: SidebarItem[] = [
  {
    id: "operations-home",
    label: "Overview",
    href: "/operations/overview",
    icon: Compass,
  },
  {
    id: "minerva-schedule",
    label: "Schedule",
    href: "/operations/schedule",
    icon: CalendarDays,
  },
  {
    id: "minerva-collections",
    label: "Collection Groups",
    href: "/operations/collections",
    icon: Folders,
  },
  {
    id: "minerva-campaigns",
    label: "Campaigns",
    href: "/operations/campaigns",
    icon: Flag,
  },
];
